// extracted by mini-css-extract-plugin
export default {"wrap":"SearchBar_wrap__Ywz4Z","input":"SearchBar_input__OeVxv","icon":"SearchBar_icon__zwjme"};